module.exports = __webpack_public_path__ + "media/images/official/special_workcation_10-2c5ceb86df5c632d07516329f69e9f2d.jpg";